<template>
    <div class="eachars-box pie">
        <div id="pie1">
            <!-- 为 ECharts 准备一个具备大小（宽高）的 DOM -->
            <div id="main1" style="float:left;width:100%;height: 300px"></div>
        </div>
    </div>
</template>

<script>
// import { playNationalProportion } from '@/resource/api/ugcIndex.js'
import { trendChartData } from '@/resource/api/ugcIndex.js'
export default {
  data () {
    return {
      echartBox2: null,
      defaultDate: [
        new Date(new Date(new Date().toLocaleDateString()).getTime() - 7 * 24 * 60 * 60 * 1000).getTime(),
        new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1).getTime()
      ],
      dataShow: [],
      city: [],
      form: {
        stageName: this.$store.state.router.anchorId,
        statisticsFields: 'provinceName',
        startTime: '',
        endTime: ''
      }
    }
  },
  created () {
  },
  mounted () {
    this.initData()
  },
  methods: {
    async getItem () {
      this.form.startTime = this.defaultDate[0]
      this.form.endTime = this.defaultDate[1]
      const res = await trendChartData({ ...this.form })
      this.dataShow = []
      this.city = []
      res.result.items.forEach(item => {
        this.dataShow.push({ name: item.dataKey, value: item.dataValue })
        this.city.push(item.dataKey)
      })
      const setDataOptin = {
        legend: {
          left: 'center',
          top: '4%',
          data: this.city
        },
        series: [
          {
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: this.dataShow,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      this.echartBox2.setOption(setDataOptin)
    },
    // 初始化图标
    initData () {
      this.getItem()
      // 基于准备好的dom，初始化echarts实例
      var myChart = this.$echarts.init(document.getElementById('main1'))
      // 绘制图表
      this.echartBox2 = myChart
      this.echartBox2.setOption({
        title: {
          text: '播放量全国占比',
          left: '2%',
          top: '4%',
          textStyle: { color: '#33343B', fontStyle: 'normal', fontWeight: 500, fontSize: 18 }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        legend: {
          left: 'center',
          top: '4%',
          data: [] // ['重庆', '成都', '江西', '北京', '山西']
        },
        series: [
          {
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: [
              // { value: 335, name: '重庆' },
              // { value: 310, name: '成都' },
              // { value: 234, name: '江西' },
              // { value: 135, name: '北京' },
              // { value: 1548, name: '山西' }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      })
    }
  }
}
</script>
